<div class="pop-bg"></div>
<div class="pop-position">
  <div class="row col-md-12 p-0 grey header-popup-box">
    <span title="Concluder Dashboard Heatmap Calculation" class="col-md-10 col-sm-10 p-0">
      <div class="heading-panel pl-10">
        <!-- <span class="text-sm text-ellipsis heading-txt flex">Concluder Help Image </span> -->
        <span class="text-sm text-ellipsis heading-txt flex ml-10">Concluder Dashboard Heatmap Logic </span>
      </div>
    </span>
    <span title="close" class="pull-right text-right col-md-2 col-sm-2 pv-10 cursor" (click)="CloseModal()">
      <i class="fa fa-times" aria-hidden="true"></i>
    </span>
  </div>
  <div class="col-md-12 p-0">
    <img src="assets/images/HeatMapLogic.JPG" alt="">

  </div>
</div>
